import {
    actions as liveCheckActions,
    selectors as liveCheckSelectors,
} from '../../appstate';
import { liveCheckTripAction } from '../liveCheckTrip';
import {
    serializeLiveCheckTripParams,
} from '../utils';
import Events from './events/liveCheckItineraryEvents';

const controllerMap = {};

function _handleAbort(itineraryId) {
    const { prevController } = controllerMap[itineraryId] || {};
    if (prevController) {
        prevController.abort();
    }

    const controller = new AbortController();
    controllerMap[itineraryId] = { controller };
    return controller.signal;
}

function liveCheckItinerary(tripIds, opts) {
    const {
        abortable = true,
        itineraryId,
        seats = 1,
        wheelchairs = 0,
        fareVersion = 'v2',
        tripLiveCheckData,
        ...tripOpts
    } = opts;

    let signal;
    if (abortable) {
        signal = _handleAbort(itineraryId);
    }

    return async (dispatch, getState) => {
        if (!tripIds) {
            return;
        }

        await Promise.all(tripIds.map((tripId) => {
            const tripLCOpts = {
                ...tripOpts,
                itineraryId,
                seats,
                wheelchairs,
                fareVersion,
                selectedFare: tripLiveCheckData[tripId].selectedFare,
                exchangeRate: tripLiveCheckData[tripId].exchangeRate,
                eventMeta: {
                    originalPricing: tripLiveCheckData[tripId].originalPricing,
                    lastScraped: tripLiveCheckData[tripId].lastScraped,
                },
            };

            return dispatch(liveCheckTripAction.liveCheckTrip(tripId, tripLCOpts, signal));
        }));

        controllerMap[itineraryId] = undefined;

        const lcParamsArr = tripIds.map((tripId) => ({
            tripId,
            seats,
            wheelchairs,
            selectedFare: tripLiveCheckData[tripId].selectedFare,
        }));
        const originalPricingObj = tripIds.reduce((obj, tripId) => ({
            ...obj,
            [tripId]: tripLiveCheckData[tripId].originalPricing,
        }), {});

        const liveCheckSummaryStatus = liveCheckSelectors.selectLiveCheckSummaryStatus(
            getState(),
            lcParamsArr,
            originalPricingObj,
        );

        Events.liveCheckItineraryCompleted({
            label: liveCheckSummaryStatus,
            itineraryId,
        });
    };
}

function resetLiveCheckItinerary(tripIds, opts) {
    return (dispatch) => {
        tripIds.forEach((tripId) => {
            const lcId = serializeLiveCheckTripParams({ tripId, ...opts });
            dispatch(liveCheckActions.removeTripLiveChecks(lcId));
            dispatch(liveCheckTripAction.reset({ tripId, ...opts }));
        });
    };
}

const liveCheckItineraryAction = {
    liveCheckItinerary,
    resetLiveCheckItinerary,
};

export {
    liveCheckItineraryAction,
};
